function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "lock",
  fill: "#797979",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.9285714,18.8125 L31.8928571,18.8125 L31.8928571,12.765625 C31.8928571,5.72773437 26.1080357,0 19,0 C11.8919643,0 6.10714286,5.72773437 6.10714286,12.765625 L6.10714286,18.8125 L4.07142857,18.8125 C1.82366071,18.8125 0,20.6181641 0,22.84375 L0,38.96875 C0,41.1943359 1.82366071,43 4.07142857,43 L33.9285714,43 C36.1763393,43 38,41.1943359 38,38.96875 L38,22.84375 C38,20.6181641 36.1763393,18.8125 33.9285714,18.8125 Z M25.1071429,18.8125 L12.8928571,18.8125 L12.8928571,12.765625 C12.8928571,9.43144531 15.6325893,6.71875 19,6.71875 C22.3674107,6.71875 25.1071429,9.43144531 25.1071429,12.765625 L25.1071429,18.8125 Z",
  id: "Shape"
})));
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "43px",
    viewBox: "0 0 38 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.bf12535d677597df1191bc7bbb95efb2.svg";
export { ForwardRef as ReactComponent };